export const BIEventsList = {
  REMOVE_ITEM_FORM_CART: {
    evid: 115,
  },
  VIEW_MINI_CART: {
    evid: 50,
  },
  CLICK_TO_VIEW_CART_PAGE: {
    evid: 130,
  },
  CART_WIDGET_LOADED: {
    evid: 211,
  },
  UPDATE_QUANTITY: {
    evid: 116,
  },
};
